export enum TicketStatusEnum {
  NEW = 0,
  NEW_MESSAGE = 1,
  REPLIED = 2,
  ASSIGNED = 3,
  RESOLVED = 4,
  CLOSED = 5,
}

export enum TicketMessageTypesEnum {
  USER_MESSAGE = 0,
  ADMIN_MESSAGE = 1,
  ADMIN_NOTE = 2,
}
